"use client"

import { useEffect, Suspense, lazy } from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import "./App.css" // Global styles
import "./responsive.css"
import "toastr/build/toastr.min.css" // Import Toastr CSS
import toastr from "toastr" // Import Toastr
import Footer from "./components/Footer/Footer"
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary"

// Lazy load components for better performance
const ClientDetails = lazy(() => import("./components/ClientDetails/ClientDetails"))
const DPDuesDetails = lazy(() => import("./components/ClientDetails/DPDuesDetails"))
const Status = lazy(() => import("./components/ClientDetails/Status"))
const StatusFailed = lazy(() => import("./components/ClientDetails/StatusFailed"))

// Loading component
const LoadingSpinner = () => (
  <div className="page-loading">
    <div className="spinner-border text-success" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
    <p style={{ margin: 0, color: "rgba(67,67,67,0.7)" }}>Loading...</p>
  </div>
)

const App = () => {
  useEffect(() => {
    // Set Toastr options globally
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000", // Auto hide duration
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    }

    // Add custom styles for Toastr
    const customToastrStyles = () => {
      const style = document.createElement("style")
      style.innerHTML = `
        .toast {
          background-color: #34B350 !important; /* Custom background color */
          color: #ffffff; /* Text color */
          border-radius: 5px; /* Rounded corners */
          padding: 15px; /* Padding inside toast */
        }
          .toast-error {
          background-color: red !important; /* Custom red background for errors */
        }
      `
      document.head.appendChild(style)
    }

    customToastrStyles() // Apply custom styles
  }, [])

  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<ClientDetails />} />
                <Route path="/dpduesdetails" element={<DPDuesDetails />} />
                <Route path="/status" element={<Status />} />
                <Route path="/statusfailed" element={<StatusFailed />} />
                <Route
                  path="*"
                  element={
                    <div className="not-found-page">
                      <h1>404</h1>
                      <p>The page you are looking for does not exist.</p>
                      <a href="/">Go to DP Dues Login</a>
                    </div>
                  }
                />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App
